import React, { useState } from "react";
import { Flex, Button, Form, FormInput, Text, AddIcon } from "@fluentui/react-northstar";
import Constants from "../../../../constants/text-constants";
import RegExConst from "../../../../constants/regex";
import PropTypes from "prop-types";

const TeamsCallingLocationForm = (props) => {
  const { onSave } = props;
  const [locationPhoneNumber, setLocationPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [displayError, setDisplayError] = useState(false);
  const numberOnlyRegex = new RegExp(RegExConst.NUMBER_ONLY);

  const onSaveClicked = async () => {
    setDisplayError(false);
    setLoading(true);

    if (! await onSave({
      description: Constants.MICROSOFT_LOCATION,
      phoneNumber: locationPhoneNumber,
    })) {
      setDisplayError(true);
      setLoading(false);
    }
  }

  const setPhoneNumber = (event) => {
    const value = event.target.value;
    if (value.length > 20) return;

    // allow numbers only
    if (numberOnlyRegex.test(value)) {
      setLocationPhoneNumber(value);
      setDisplayError(false);
    }
  };

  const disableAddButton = locationPhoneNumber.length === 0 || loading;

  return (
    <Flex
      fill
      column
      hAlign="center"
      className="full-width tcm-form"
      space="between"
    >
      <Form className="teams-calling-location-form" data-testid="teamsCallingLocationForm">
        <FormInput
          id="phoneNumber"
          fluid
          data-testid="phoneNumberField"
          label={Constants.PHONE_NUMBER}
          onChange={setPhoneNumber}
          value={locationPhoneNumber}
        />
        {props.children}
        <Button
          primary
          icon={(<AddIcon />)}
          loading={loading}
          className="capitalize align-self-center"
          data-testid="teamsCallingLocationSaveButton"
          onClick={onSaveClicked}
          disabled={disableAddButton}
          content={Constants.ADD_LOCATION}
        />
      </Form>
      {displayError ? <Text data-testid="locationFormError" align="center" error>{Constants.FAILED_TO_ADD_LOCATION}</Text> : null}
    </Flex>
  );
}

TeamsCallingLocationForm.propTypes = {
  onSave: PropTypes.func,
};

TeamsCallingLocationForm.defaultProps = {

}

export default TeamsCallingLocationForm;